<template>
  <div>
    <div class="searchbox"><i class="el-icon-search" @click="showSearch" style="cursor: pointer;"></i></div>
    <form class="search-form" :class="{'is-visible': showSearchBox}"> 
      <div class="search-form-inner">
        <div class="regular-search mb-5">
          <h4 class="search-title mb-2">Search by Marker/Celltype</h4>
          <el-row class="mb-3">
            <el-col :span="7">
              <el-select v-model="regularSearch"
              placeholder="Select search content" style="width: 150px;">
                <el-option
                  v-for="(item, index) in regularSearchOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="13">
              <el-autocomplete style="width: 100%;" :trigger-on-focus="false" @change="handleTypeChange"
                placeholder="Search content..." clearable :fetch-suggestions="querySearch"
                v-model="regularSearchContent" @keyup.enter.native="searchEnter">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-autocomplete>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" :disabled="regularSearchContent.length==0" @click="goSearch">Search</el-button>
            </el-col>
          </el-row>
          <!-- Marker Advanced Options -->
          <el-row v-if="regularSearch === 'celltype'">
            <el-col>
              <span class="me-4">Advanced Options</span>
              <el-select v-model="celltypeSpecies" clearable @change="handleCtSpeciesChange"
              placeholder="Species(--option--)" class="me-3">
                <el-option
                  v-for="(item, index) in speciesOptions"
                  :key="index"
                  :label="item.charAt(0).toUpperCase()+item.slice(1).replace('_',' ')"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="celltypeTissue" clearable
              placeholder="Tissue(--option--)" style="width: 208px;">
                <el-option
                  v-for="(item, index) in tissueOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="sequence-search">
          <h4 class="search-title">Search by Sequence</h4>
          <el-row :gutter="30">
            <el-col :span="14">
              <el-input type="textarea" :rows="6" v-model="blastSeq">
              </el-input>
            </el-col>
            <el-col :span="10" style="text-align: center;">
              <el-select v-model="blastSpecies" placeholder="Species..." class="mb-2">
                <el-option
                  v-for="(item, index) in speciesOptions"
                  :key="index"
                  :label="item.charAt(0).toUpperCase()+item.slice(1).replace('_',' ')"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="blastProgram" placeholder="Program...">
                <el-option
                  v-for="(item, index) in blastProgramOptions"
                  :key="index"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button style="margin-top: 8.2px; display: inline-block; width: 205.67px;"
              type="primary" :disabled="blastProgram===''||blastSpecies===''||blastSeq===''" @click="goBlastSearch">
                GO
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="search-close">
        <i class="bi bi-arrows-angle-contract" @click="hideSearch"></i>
      </div>
    </form>
  </div>
</template>

<script>
import celltypeTree from '@/assets/json/celltype.json'

function toggleBody(isPin){
  if(isPin){
    document.body.style.height = '100vh'
    document.body.style['overflow-y'] = 'hidden'
  }else{
    document.body.style.height = 'unset'
    document.body.style['overflow-y'] = 'auto'
  }
}

function getTreeData(tree){
  let celltype = new Array
  for(let node of tree){
    if(node.children){
      celltype.push(...getTreeData(node.children))
    }
    celltype.push({
      name: node.label, 
      value: node.value, 
      type: node.type, 
      id: node.id, 
      self_po: node.id.split('->').slice(-1)[0], 
      children: node.children
    }) //Math.round(Math.random()*100)
  }
  return celltype
}

export default {
  data() {
    return {
      allData: celltypeTree,
      showSearchBox: false,
      regularSearch: 'marker',
      regularSearchOptions: [
        {label: 'Marker Genes', value: 'marker'},
        {label: 'Cell type', value: 'celltype'},
        {label: 'Cell type ID', value: 'celltype_id'}
      ],
      regularSearchContent: '',

      speciesOptions: Object.keys(celltypeTree),
      celltypeSpecies: '',
      celltypeTissue: '',

      blastSeq: '',
      blastSpecies: '',
      blastProgram: '',
      blastProgramOptions: [
        {text: 'BLASTN (search nucleotide databases using a nucleotide query)', value: 'blastn'},
        {text: 'BLASTP (search protein databases using a protein query)', value: 'blastp'},
        {text: 'BLASTX (search protein databases using a translated nucleotide query)', value: 'blastx'}
      ]
    }
  },
  computed: {
    tissueOptions() {
      if(this.celltypeSpecies.length>0){
        return  getTreeData(this.allData[this.celltypeSpecies])
        .filter(item=>item.type==='Tissue')
        .map(d=>{return {label: d.name, value: d.self_po+'-'+d.name}})
        .filter((item, index, arr) => {
          return arr.findIndex(t => t.value === item.value) === index
        })
      }else{
        return []
      }
    },
    celltypeOptions() {
      let result = new Array
      if(this.celltypeSpecies.length>0){
        if(this.celltypeTissue != ''){
          result = getTreeData(this.allData[this.celltypeSpecies])
          .filter(item=>{return item.id.split('->').indexOf(this.celltypeTissue.split('-')[0])!==-1&&item.type==='Cell'})
          .map(d=>{return {value: d.name}})
          .filter((item, index, arr) => {
            return arr.findIndex(t => t.value === item.value) === index
          })
        }else{
          result = getTreeData(this.allData[this.celltypeSpecies])
          .filter(item=>item.type==='Cell')
          .map(d=>{return {value: d.name}})
          .filter((item, index, arr) => {
            return arr.findIndex(t => t.value === item.value) === index
          })
        }
      }
      return result
    }
  },
  methods: {
    showSearch() {
      this.showSearchBox = true
      toggleBody(1)
    },
    hideSearch() {
      this.showSearchBox = false
      toggleBody(0)
    },
    handleCtSpeciesChange() {
      this.celltypeTissue = ''
    },
    searchEnter(params) {
      let keyCode = window.event?params.keyCode:params.which
      if(keyCode == 13 && this.regularSearchContent) {
        this.goSearch()
      }
    },
    handleTypeChange() {
      this.searchContent = ''
    },
    querySearch(queryString, cb) {
      let queryList = this.celltypeOptions
      let results = queryString?queryList.filter(this.createFilter(queryString)):queryList
      cb(results)
    },
    createFilter(queryString) {
      return (queryListItem) => {
        return (queryListItem.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    goSearch() {
      const searchOptions = this.celltypeSpecies+';'+this.celltypeTissue
      this.hideSearch()
      this.$router.push({
        path: '/search',
        query: {
          searchType: this.regularSearch,
          searchContent: this.regularSearchContent,
          searchOptions: searchOptions
        }
      })
    },
    goBlastSearch() {
      let formatSeq = ''
      if(this.blastSeq[0]!='>'){
        formatSeq = '>SearchingSeq\r\n'+this.blastSeq
      }else{
        formatSeq = this.blastSeq
      }

      this.$store.commit('updateBlastseq', formatSeq)
      this.$store.commit('changeFromSeaching', true)
      setTimeout(()=>{
        this.hideSearch()
        this.$router.push({
          path: '/tools/blast',
          query: {searchSpecies: this.blastSpecies, searchProgram: this.blastProgram}
        })
      },100)


    }
  },
}
</script>

<style>
  .searchbox {
    animation: searchbox 1s;
    font-size: 24px;
    float: right;
    height: 75px;
    line-height: 75px;
    margin-left: 20px;
    transition: all .5s ease !important;
  }

  .searchbox:hover {
    color: #2ca25f
  }

  .search-form {
    transition: opacity .25s ease;
    overflow: hidden;
    z-index: 9999;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    visibility: hidden;
    opacity: 0;
    backdrop-filter: blur(10px);
  }

  .search-form.is-visible {
    visibility: visible;
    opacity: 1;
    animation: elastic .5s;
    background-color: rgba(255, 255, 255, 0.7);
  }

  .search-form .search-close {
    position: absolute;
    font-size: 28px;
    width: 35px;
    height: 35px;
    background: 0 0;
    top: 20px;
    right: 15px;
    cursor: pointer;
  }

  .search-form .search-form-inner {
    max-width: 640px;
    padding: 0 20px;
    margin: auto;
    text-align: left;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    height: 300px;
    top: 0;
    bottom: 0;
  }

  .search-title {
    color: #2ca25f;
    font-weight: 600;
  }

  @keyframes searchbox {
    0% {
      opacity: 0;
      transform: translateX(30px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    } 
  }

  @keyframes elastic {
    0% {
      transform: scale(0);
    }
    55% {
      transform: scale(1);
    }
    70% {
      transform: scale(.98);
    }
    100% {
      transform: scale(1);
    }
  }
</style>